var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStar = function SvgStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74512 0.681641L5.76074 2.75977L7.99512 3.08789C8.18262 3.11914 8.33887 3.24414 8.40137 3.43164C8.46387 3.60352 8.41699 3.80664 8.27637 3.93164L6.65137 5.54102L7.04199 7.82227C7.07324 8.00977 6.99512 8.19727 6.83887 8.30664C6.68262 8.43164 6.47949 8.43164 6.30762 8.35352L4.30762 7.27539L2.29199 8.35352C2.13574 8.43164 1.93262 8.43164 1.77637 8.30664C1.62012 8.19727 1.54199 8.00977 1.57324 7.82227L1.94824 5.54102L0.323242 3.93164C0.198242 3.80664 0.151367 3.60352 0.198242 3.43164C0.260742 3.24414 0.416992 3.11914 0.604492 3.08789L2.85449 2.75977L3.85449 0.681641C3.93262 0.509766 4.10449 0.400391 4.30762 0.400391C4.49512 0.400391 4.66699 0.509766 4.74512 0.681641Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export default ForwardRef;